import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  font-family: 'Segoe UI', sans-serif;
  background-color: #f9f9fb;
  min-height: 100vh;
`;

export const Sidebar = styled.div`
  width: 350px;
  background-color: white;
  padding: 2rem 1.5rem;
  box-shadow: 2px 0 5px rgba(0,0,0,0.05);
`;

export const SidebarHeader = styled.div`
  font-weight: bold;
  font-size: 0.95rem;
  color: #000;
  margin: 1.5rem 0 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
export const ToggleGroup = styled.ul`
  display: flex;
  border: 1px solid #ccc;
  border-radius: 999px;
  padding: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
  background: white;
`;

export const ToggleItem = styled.li<{ selected?: boolean }>`
  flex: 1;
  text-align: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: ${({ selected }) => (selected ? 'bold' : 500)};
  color: ${({ selected }) => (selected ? '#2563eb' : '#6b7280')}; /* blue-600 vs gray-500 */
  background-color: ${({ selected }) => (selected ? '#bfdbfe' : 'white')}; /* light blue background */
  border-right: 1px solid #ccc;

  &:last-child {
    border-right: none;
  }

  &:first-child {
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;
  }

  &:last-child {
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
  }
`;


export const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SidebarItem = styled.li<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: ${({ selected }) => (selected ? 'bold' : 500)};
  color: ${({ selected }) => (selected ? '#000' : '#8D8D8D')};
  margin-bottom: 0.7rem;
  cursor: pointer;

  &::before {
    content: ${({ selected }) => (selected ? "'•'" : "''")};
    color: black;
    font-size: 1.2rem;
    margin-right: 8px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 2rem 3rem;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const DateLabel = styled.div`
  font-weight: 500;
`;

export const ViewType = styled.div`
  background: #f3f3f3;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: 600;
`;


export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  box-sizing: border-box;

  @media (max-width: 1370px) {
    grid-template-columns: repeat(4, minmax(215px, 1fr));x */
    padding: 0 1rem; 
    margin-left: -2.5rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

    @media (min-width: 1900px) {
    grid-template-columns: repeat(4, minmax(250px, 1fr));
    gap: 2.5rem; 
  }
`;

export const Card = styled.div<{ color: string }>`
  background-color: ${({ color }) => color || '#9B5DE5'};
  border-radius: 1.25rem;
  padding: 0.8rem;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  overflow: hidden;
  flex-shrink: 1;

  @media (max-width: 1370px) {
    height: 150px;
  }
`;

export const CardTitle = styled.div`
  font-size: clamp(0.9rem, 1vw + 0.8rem, 1rem);
  font-weight: 600;
  margin-bottom: 0.15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardCount = styled.div`
  font-size: clamp(1.8rem, 2vw + 1.5rem, 2.5rem);
  font-weight: bold;
  line-height: 1;
  margin: 0.6rem 0;
`;

export const CardIcons = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: auto; // Pushes to bottom
`;



export const IconButton = styled.button<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#bfdbfe' : '#f1f5f9')};
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #e0e7ff;
  }

  svg {
    font-size: 1.25rem;
    color: ${({ selected }) => (selected ? '#2563eb' : '#4b5563')}; // blue-600 or gray-700
  }
`;

export const DownloadButton = styled.button<{ selected?: boolean; fontColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#bfdbfe' : '#f1f5f9')};
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  color: ${({ fontColor }) => fontColor || '#4b5563'}; // <- text color

  &:hover {
    background-color: #e0e7ff;
  }

  svg {
    font-size: 1.25rem;
    color: ${({ selected }) => (selected ? '#2563eb' : '#4b5563')}; // icon color stays
  }
`;




export const ChartContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem 3rem;
  display: flex;
  gap: 4rem;
  align-items: flex-end;
  height: 220px;
`;

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BarCount = styled.div<{ height: number; color: string }>`
  width: 50px;
  height: ${({ height }) => height}px;
  background-color: ${({ color }) => color};
  border-radius: 6px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-weight: bold;
  padding-bottom: 4px;
  span {
    color: #767676;
    font-weight: bold;
  }
`;
export const BarCountText = styled.span`
color: #767676;`;

export const BarLabel = styled.div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
`;
